const caPostcode = (value) => {
  const pattern = /^[A-Z]\d[A-Z] \d[A-Z]\d$/;
  
  if (!(pattern.test(value))) {
    return ['checkout.error.formFields.postalCode', 'X0X 0X0'];
  }
};

export default caPostcode;
